import { useCallback, useEffect, useMemo, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LocaleContext, readLocale, writeLocale, type Locale } from "@/i18n";
import LoginPage from "@/pages/LoginPage";
import Shell from "@/pages/Shell";
import StatusPage from "@/pages/StatusPage";

export default function App() {
  const { staff, checking } = useAuth();
  const [locale, setLocaleState] = useState<Locale>(() => readLocale());
  const setLocale = useCallback((l: Locale) => { writeLocale(l); setLocaleState(l); }, []);
  const localeValue = useMemo(() => ({ locale, setLocale }), [locale, setLocale]);
  useEffect(() => { document.documentElement.lang = locale; }, [locale]);

  // ⛔ Render NOTHING while the stored token is being checked. Treating "unknown" as "logged out"
  // flashes the sign-in form at someone who is already signed in, then replaces it a moment later.
  if (checking) return null;

  return (
    <LocaleContext.Provider value={localeValue}>
      {staff ? (
        <Routes>
          <Route path="/status" element={<StatusPage />} />
          <Route path="*" element={<Shell />} />
        </Routes>
      ) : <LoginPage />}
    </LocaleContext.Provider>
  );
}
